module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-976b5a527c1b428d66f24d30438ca547.png";